// 合作伙伴数据
export const partnersData: { name: string; logo: string; description: string; id: number }[] = [
  {
    name: '环球足球奖',
    description: '独家博彩赞助',
    logo: 'hqzqj.png',
    id: 17,
  },
  {
    name: '尤文图斯',
    description: '亚太区独家赞助',
    logo: 'ywts.png',
    id: 15,
  },
  {
    name: '本菲卡',
    description: '亚太区独家赞助',
    logo: 'bfk.png',
    id: 19,
  },
];

// 社区数据
export const communityData: { name: string; logo: string; url: string }[] = [
  {
    name: 'Facebook',
    logo: '/images/common/footer/facebook.png',
    url: 'https://www.facebook.com/people/Op7sports/61579594983274/?mibextid=wwXIfr&rdid=NIXDNuckJIfhUyK6&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1KHu8XpK6S%2F%3Fmibextid%3DwwXIfr',
  },
  {
    name: 'X',
    logo: '/images/common/footer/x.png',
    url: 'https://x.com/op7sports?s=21',
  },
  {
    name: 'Youtube',
    logo: '/images/common/footer/youtub.png',
    url: 'https://www.youtube.com/@op7sports?si=02hKVBsnW2g1q94U',
  },
  {
    name: 'instagram',
    logo: '/images/common/footer/Instagram.png',
    url: 'https://www.instagram.com/op7sports/profilecard/?igsh=NnJsM2ZuZHNscjhv',
  },
  {
    name: 'Telegram',
    logo: '/images/common/footer/telegram.png',
    url: 'https://t.me/op7io',
  },
  {
    name: 'Email',
    logo: '/images/common/footer/email.png',
    url: 'mailto:op@op777.io',
  },
];

// 游戏供应商数据
export const gameProviderData: { logo: string }[] = [
  {
    logo: '/images/common/footer/1.png',
  },
  {
    logo: '/images/common/footer/2.png',
  },
  {
    logo: '/images/common/footer/3.png',
  },
  {
    logo: '/images/common/footer/4.png',
  },
  {
    logo: '/images/common/footer/5.png',
  },
  {
    logo: '/images/common/footer/6.png',
  },
  {
    logo: '/images/common/footer/7.png',
  },
  {
    logo: '/images/common/footer/8_1.png',
  },
  {
    logo: '/images/common/footer/9.png',
  },
  {
    logo: '/images/common/footer/10.png',
  },
  {
    logo: '/images/common/footer/11.png',
  },
  {
    logo: '/images/common/footer/12.png',
  },
  {
    logo: '/images/common/footer/13.png',
  },
  {
    logo: '/images/common/footer/14.png',
  },
];
